import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from './images/logo.png';
import { MD5 } from 'crypto-js';
import { BASE_URL } from './Constants'; // Import BASE_URL from your constants


const LoginForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    emp_code: '',
    password: '',
  });
  const [responseMessage, setResponseMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${BASE_URL}login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData),
      });

      const result = await response.json();

      if (!response.ok || !result.status) {
        setResponseMessage(result.error || 'Login failed');
        return;
      }

      const token = result.token;
      // const expirationTime = Date.now() + 3595000;

      localStorage.setItem('authToken', token);
      // localStorage.setItem('exp', expirationTime);

      const profileResponse = await fetch(`${BASE_URL}/profile`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!profileResponse.ok) {
        setResponseMessage('Error fetching profile');
        return;
      }

      const profileResult = await profileResponse.json();

      const hashedPassword = MD5('adnet2008').toString();
      const getPassword = profileResult.profile.password;

      if (hashedPassword === getPassword) {
        navigate('/reset-password');
        // window.location.reload();
        console.log('Please change your password');
        return;
      }

      if (profileResult.status) {
        localStorage.setItem('userProfile', JSON.stringify(profileResult.profile));
        navigate('/dashboard');
      } else {
        setResponseMessage(`Error fetching profile: ${profileResult.message}`);
      }
    } catch (error) {
      setResponseMessage(`Error: ${error.message}`);
    }
  };

  return (
    <div className="container-scroller">
      <div className="container-fluid page-body-wrapper full-page-wrapper">
        <div className="content-wrapper d-flex align-items-center auth px-0">
          <div className="row w-100 mx-0">
            <div className="col-lg-4 mx-auto">
              <div className="auth-form-light text-left py-5 px-4 px-sm-5">
                <div className="brand-logo">
                  <img src={logo} alt="logo" style={{ width: '100%' }} />
                </div>
               
                <center><h6 className="font-weight-light">Please login to your account</h6></center>
                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control form-control-lg"
                      id="exampleInputUserId1"
                      placeholder="User ID"
                      value={formData.emp_code}
                      onChange={handleChange}
                      name="emp_code"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="password"
                      className="form-control form-control-lg"
                      placeholder="Enter your password"
                      value={formData.password}
                      onChange={handleChange}
                      name="password"
                      required
                    />
                  </div>
                  <div className="mt-3 d-grid gap-2">
                    <button
                      type="submit"
                      className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
                    >
                      LOGIN
                    </button>
                  </div>
                  {responseMessage && (
                    <div className="mt-3 text-danger text-center">
                      {responseMessage}
                    </div>
                  )}
                  <div className="text-center mt-4">
  <small style={{ color: "#888" }}>Version 1.0</small>
</div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
